module.exports = __webpack_public_path__ + "img/RCN.2622c848.svg";